exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".axis path,\n.axis line {\n  fill: none;\n  stroke: #000;\n  shape-rendering: crispEdges; }\n\n.area1 {\n  fill: #f9d057b3; }\n\n.area2 {\n  fill: #36aeafa6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/multiAreaChart/multiAreachart.style.scss
// module id = 1569
// module chunks = 0